import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import CloseBtn from '../common/CloseIcon';
import {actionLogin, toggleModal, toggleModalType} from '../../redux/actions';
import {useHistory} from 'react-router';
import {HOST_NAME} from "../../constants";


const Login = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');


    const closeModal = () => {
        dispatch(toggleModal());
    }

    const showRegister = () => {
        closeModal()
        dispatch(toggleModalType('register'));
        dispatch(toggleModal());
    }

    const showPasswordReset = () => {
        closeModal()
        dispatch(toggleModalType('sendlink'));
        dispatch(toggleModal());
    }

    const doLogin = () => {
        const data = {
            username,
            password,
        }
        dispatch(actionLogin(data))
        closeModal()

    }

    const fbLoginRedirect = () => {
        //history.push('/fblogin')
        closeModal()
        window.location.href = `${HOST_NAME}/fblogin`

    }


    // @ts-ignore
    return <div>
            <div className='close-btn' onClick={closeModal}>
                <CloseBtn/>
            </div>
            <div className='login'>
                <h2 style={{marginTop:47,fontSize:'22px', fontWeight:'bold'}}>Tere tulemast!</h2>
                {/*<div className='py-24'>*/}
                {/*    <button type="button" className="btn btn-primary" onClick={fbLoginRedirect}>Logi sisse Facebookiga</button>*/}
                {/*</div>*/}
                <div>
                    <span>
                        <p>
                            Logi sisse kasutajanimega
                        </p>
                    </span>
                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            id="email"
                            value={username}
                            onChange={(ev)=>{setUsername(ev.target.value)}}
                               placeholder="kasutajanimi"/>
                    </div>
                    <div className="form-group">
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            value={password}
                            onChange={(ev)=>{setPassword(ev.target.value)}}
                            placeholder="parool"/>
                    </div>
                    <button type="button" className="btn btn-success" onClick={doLogin}>Logi sisse</button>
                    <div className='footerStart'>
                        <span>
                            <p>
                                Ei ole kontot?<br />
                                <a onClick={showRegister}> Registreeru!</a>
                            </p>
                        </span>
                        <div>
                            <p>
                            <a onClick={showPasswordReset}>Unustasid parooli?</a>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

}

export default Login;
